import { render, staticRenderFns } from "./DataTableHeader.vue?vue&type=template&id=65266519&scoped=true"
import script from "./DataTableHeader.vue?vue&type=script&lang=ts"
export * from "./DataTableHeader.vue?vue&type=script&lang=ts"
import style0 from "./DataTableHeader.vue?vue&type=style&index=0&id=65266519&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "65266519",
  null
  
)

export default component.exports